<template>
  <div v-cloak class="row justify-content-center">
    <div class="col col-sm-8 align-self-center">
      <div class="card">
        <div class="card-body">
          <div class="row my-3">
            <div class="col d-flex justify-content-center align-items-center">
              <h1 class="mb-0">Feedback</h1>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-10">
              <div class="input-group">
                <el-input type="textarea" v-model="message"></el-input>
              </div>
            </div>
            <div class="col-md-2">
              <button
                class="btn btn-sm btn-primary mr-4"
                @click="handleFeedback"
              >
                Send
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    order: {
      type: Object,
    },
  },
  data() {
    return {
      message: null,
    };
  },
  methods: {
    handleFeedback() {
      let self = this;

      axios
        .post(`/api/orders/${this.order.id}/activity-log`, {
          message: "Customer feedback: " + this.message,
        })
        .then((res) => {
          this.$message({
            type: "success",
            message: "Thanks for your feedback",
          });

          this.message = null;
        })
        .catch((errors) => {
          this.form.errors.record(errors.response.data.errors);
        });
    },
  },
};
</script>
